/** Entitlement keys returned by the profile API. Prefer these over user.premium. */
export const ENTITLEMENTS = {
  unlimitedAskDynamo: "unlimited_ask_dynamo",
  multipleDogs: "multiple_dogs",
  packQuestions: "pack_questions",
  dogMemory: "dog_memory",
  dogJournal: "dog_journal",
  professionalReports: "professional_reports",
  seasonalPortraits: "seasonal_portraits",
  unlimitedPhotoUploads: "unlimited_photo_uploads",
  advancedBehaviourAnalysis: "advanced_behaviour_analysis",
} as const

export type EntitlementKey = (typeof ENTITLEMENTS)[keyof typeof ENTITLEMENTS]

export function hasEntitlement(
  entitlements: string[] | null | undefined,
  key: EntitlementKey | string,
): boolean {
  return Array.isArray(entitlements) && entitlements.includes(key)
}
